
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsCaV1 } from '@iabtcf/gpp/encoder/section/UsCaV1.js'; 

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export function updateCMP( consentToAll, cmpApi, consentToSharing ) {
    console.log("LayerStateCalifornia: updateCMP() consentToAll=" + consentToAll );

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/field/UsCaV1Field.ts

    //  https://github.com/IABTechLab/iabgpp-es/blob/master/modules/cmpapi/src/encoder/section/UsCaV1.ts

    //  https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/blob/main/Sections/US-States/CA/GPP%20Extension%3A%20IAB%20Privacy%E2%80%99s%20California%20Privacy%20Technical%20Specification.md
  

    let sections = cmpApi.getApplicableSections();

      if ( sections.indexOf( UsCaV1.ID ) == -1 ) {
        sections.push( UsCaV1.ID );
        cmpApi.setApplicableSections(sections);
      }

      if ( consentToAll ) {
        cmpApi.setFieldValue(UsCaV1.NAME, 'SensitiveDataProcessing',  Array( 8 ).fill( 2 ) );
      }

      cmpApi.setFieldValue(UsCaV1.NAME, 'Version', 1);
      cmpApi.setFieldValue(UsCaV1.NAME, 'SaleOptOutNotice', 1);         // 1 = notice given
      cmpApi.setFieldValue(UsCaV1.NAME, 'SharingOptOutNotice', 1);  // 1 = notice given
      cmpApi.setFieldValue(UsCaV1.NAME, 'SensitiveDataLimitUseNotice', 1);  // 1 = notice given

      cmpApi.setFieldValue(UsCaV1.NAME, 'SaleOptOut', consentToSharing ? 2 : 1 );     // 1 = opted out, 2 = consent/did not opt out
      cmpApi.setFieldValue(UsCaV1.NAME, 'SharingOptOut', consentToSharing ? 2 : 1 ); // 1 = opted out, 2 = consent/did not opt out

      cmpApi.setFieldValue(UsCaV1.NAME, 'KnownChildSensitiveDataConsents', [0,0]); // 0 = not applicable
      cmpApi.setFieldValue(UsCaV1.NAME, 'MspaCoveredTransaction', 1);  // 1 = yes, 2 = no
      cmpApi.setFieldValue(UsCaV1.NAME, 'MspaOptOutOptionMode', 1);   // 0 = not applicable, 1 = yes (yes means users have to opt out), 2 = no
      cmpApi.setFieldValue(UsCaV1.NAME, 'MspaServiceProviderMode', 2);  // 0 = not applicable, 1 = yes, 2 = no (no means sells/shares data)

      // todo: get GPC flag from browser and set GPC flag here...

      cmpApi.setFieldValue(UsCaV1.NAME, 'GpcSegmentType', 1);
      cmpApi.setFieldValue(UsCaV1.NAME, 'GpcSegmentIncluded', 0);
      }

export default class LayerStateCalifornia extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsCaV1.NAME;
  sectionID = UsCaV1.ID;
  dirty = false;

  sensitiveLeadText = "Consent to the Use or Disclosure of the Consumer's Sensitive Personal Information:";
  sensitiveFeatures = [
        { position: 1, description: "Which Reveals a Consumer's Social Security, Driver's License, State Identification Card, or Passport Number." },
        { position: 2, description: "Which Reveals a Consumer's Account Log-In, Financial Account, Debit Card, or Credit Card Number in Combination with Any Required Security or Access Code, Password, or Credentials Allowing Access to an Account." },
        { position: 3, description: "Which Reveals a Consumer's Precise Geolocation." },
        { position: 4, description: "Which Reveals a Consumer's Racial or Ethnic Origin, Religious or Philosophical Beliefs, or Union Membership." },
        { position: 5, description: "Which Reveals the contents of a Consumer's Mail, Email, and Text Messages unless You Are the Intended Recipient of the Communication." },
        { position: 6, description: "Which Reveals a Consumer's Genetic Data." },
        { position: 7, description: "Consisting of Biometric Information tor the Purpose of Uniquely Identifying a Consumer." },
        { position: 8, description: "Consisting of Personal Information Collected and Analyzed Concerning a Consumer's Health." },
        { position: 8, description: "Consisting of Personal Information Collected and Analyzed Concerning a Consumer's Sex Life or Sexual Orientation." }
        ];

	mounted(): void {
    console.log("California Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
          this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
          this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'TargetedAdvertisingOptOut') == 2  ? true : false;
        }
      else  {
        updateCMP( true, this.cmpApi, this.consentToSharing )
        }  
	}

  sensitiveDataChange( consentArray ) {
    console.log("LayerStateCalifornia: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 

 


  @Emit('changeViewEvent')
	saveSettingsClick(consentToAll : Boolean): string {
    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }

    updateCMP( consentToAll, this.cmpApi, this.consentToSharing )
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
